import {
  CardListLoading,
  Pagination,
  NoData,
  getTranslatedText,
  AppContext
} from '@nile/components';
import { ChoiceList } from '@shopify/polaris';
import EmptyContainer from '@nile/components/src/Containers/EmptyContainer';
import { ProjectListItem } from '@nile/projects/src/Components/Cards';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import React, { useContext, useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import envConfig from '@nile/projects/src/Config/env';
import { injectIntl } from 'react-intl';

const ScrollableWrapper = styled.div`
  overflow: auto;
  padding: 10px;
  height: 100%;
  background-color: white;
  .Polaris-Choice {
    display: flex;
    .Polaris-Choice__Control {
      margin-top: 35px;
    }
    .Polaris-Choice__Label {
      width: 100%;
    }
  }
  .Polaris-Card {
    box-shadow: none;
    border: 0.1rem solid #f0f0f6;
    margin: 0px !important;
  }
`;

const NoDataWrapper = styled.div`
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProjectListCardContainer = (props) => {
  const { intl, allowDelete, updateList } = props;
  const tabContext = useContext(TabContext);
  const [selected, setSelected] = useState([]);

  const handleChange = useCallback((value) => setSelected(value), []);
  const { accountType } = useContext(AppContext);

  useEffect(() => {
    tabContext.setRecords && tabContext.setRecords(selected);
  }, [selected]);

  useEffect(() => {
    if (tabContext.records.length !== selected.length) {
      updateList();
    }
  }, [tabContext]);

  useEffect(() => {
    setSelected([]);
  }, [props.projectList]);

  if (props?.loading) {
    return <CardListLoading />;
  }
  if (!props?.projectList?.length) {
    return (
      <NoDataWrapper>
        <NoData
          imageURL={`url(${envConfig.imageRoot}svg/ProjectEmptyState.svg)`}
          text={getTranslatedText(intl, 'alert.noProjectFound.heading')}
          description={getTranslatedText(intl, 'alert.noProjectFound.desc')}
        />
      </NoDataWrapper>
    );
  }
  return (
    <>
      <ScrollableWrapper>
        {/* {props.projectList.map((item) => (
          <ProjectListItem
            detail={item}
            allowDelete={allowDelete}
            updateList={updateList}
          />
        ))} */}
        <ChoiceList
          disabled={accountType === 'CLIENT'}
          allowMultiple
          choices={
            props?.projectList?.map((item) => ({
              label: (
                <ProjectListItem
                  accountType={accountType}
                  detail={item}
                  allowDelete={allowDelete}
                  updateList={updateList}
                />
              ),
              value: item?.projectId
            })) || []
          }
          selected={selected}
          onChange={handleChange}
        />
      </ScrollableWrapper>

      {Math.ceil(props.totalCount / props.pageSize) > 1 && (
        <Pagination
          onPageChange={props.handlePageChange}
          pages={Math.ceil(props.totalCount / props.pageSize) || 0}
          page={props.activePage}
        />
      )}
    </>
  );
};

export default injectIntl(ProjectListCardContainer);
